import { getDecimalsFromIncrement } from '@/features/dashboard/lib/orderbook-data'

/** Intl options for a price: the instrument's tick precision, else a magnitude-based guess. */
export function priceFormatOptions(
  value: string | number | undefined,
  tickSize?: string
): Intl.NumberFormatOptions {
  const tick = Number(tickSize)
  if (tickSize && tick > 0) {
    const digits = Math.min(getDecimalsFromIncrement(tick), 8)
    return { minimumFractionDigits: digits, maximumFractionDigits: digits }
  }
  const abs = Math.abs(Number(value))
  if (!Number.isFinite(abs) || abs >= 1000) return { maximumFractionDigits: 2 }
  if (abs >= 1) return { maximumFractionDigits: 4 }
  return { maximumSignificantDigits: 4 }
}

/** -1, 0 or 1 for a numeric string; 0 when missing, so missing data renders neutral. */
export function signOf(value: string | number | undefined): -1 | 0 | 1 {
  const n = Number(value)
  if (value === undefined || value === '' || !Number.isFinite(n) || n === 0) return 0
  return n > 0 ? 1 : -1
}

/** Up/down text color for a signed value (trading semantics); neutral at zero or missing. */
export function signTextClass(value: string | number | undefined): string {
  const sign = signOf(value)
  return sign > 0 ? 'text-chart-mint' : sign < 0 ? 'text-chart-red' : 'text-foreground/60'
}

export const SIGNED_PERCENT: Intl.NumberFormatOptions = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  signDisplay: 'exceptZero',
}
